
module.exports = require('./bin/error');



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/custom-error-instance/index.js
// module id = ../../../node_modules/custom-error-instance/index.js
// module chunks = 1